import React, { ComponentProps } from 'react';

import Button from '../atoms/button';
import Anchor from '../atoms/anchor';
import { Link as InternalLink } from 'gatsby';
import { SvgArrowUpCorner } from '../../../icons';
import { LoginOrRegisterButton } from './login-register-button';
import { SubmitIdeaButton } from './submit-idea-button';

type DynamicLinkProps = {
    path: string;
    label: string;
    isExternal: boolean;
    newTab: boolean;
    variant: ComponentProps<typeof Anchor>['variant'] | ComponentProps<typeof Button>['variant'];
    size: ComponentProps<typeof Anchor>['size'] | ComponentProps<typeof Button>['size'];
    buttonType: 'internal' | 'external' | 'login' | 'register' | 'submitIdea';
    appearance: 'button' | 'link';
    className?: string;
};

export function DynamicLink({
    path,
    label,
    isExternal,
    variant,
    newTab,
    appearance,
    className,
    buttonType,
    size,
}: DynamicLinkProps) {
    const isButton = appearance === 'button';

    const sharedProps = {
        iconRight: isExternal && newTab ? <SvgArrowUpCorner /> : null,
        size,
    };

    const props = isExternal
        ? {
              target: newTab ? '_blank' : undefined,
              rel: newTab ? 'noopener' : undefined,
              href: path,
              as: 'a',
          }
        : {
              to: path || '',
              as: InternalLink,
          };

    if (buttonType === 'login' || buttonType === 'register') {
        return (
            <LoginOrRegisterButton
                className={className}
                type={buttonType}
                variant={variant}
                appearance={appearance}
                size={size}
            >
                {label}
            </LoginOrRegisterButton>
        );
    }

    if (buttonType === 'submitIdea') {
        return (
            <SubmitIdeaButton
                variant={variant}
                appearance={appearance}
                size={size}
                className={className}
            >
                {label}
            </SubmitIdeaButton>
        );
    }

    if (isButton) {
        return (
            <Button
                className={className}
                variant={variant as ComponentProps<typeof Button>['variant']}
                {...sharedProps}
                {...(props as any)}
            >
                {label}
            </Button>
        );
    }

    return (
        <Anchor
            className={className}
            variant={variant as ComponentProps<typeof Anchor>['variant']}
            {...sharedProps}
            {...(props as any)}
        >
            {label}
        </Anchor>
    );
}
